<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">For Chris and David Lloyd</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MyLuckyStar_dedi-1.vue?4c0ca5ea